/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuditLogAction } from '../models/AuditLogAction';
import type { TListAuditLogResponse } from '../models/TListAuditLogResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuditService {
    /**
     * List Audit Log
     * @param entityName
     * @param actorUserId
     * @param action
     * @param fromDate
     * @param toDate
     * @param limit
     * @param page
     * @returns TListAuditLogResponse TListAuditLogResponse
     * @throws ApiError
     */
    public static listAuditLog(
        entityName?: string,
        actorUserId?: string,
        action?: AuditLogAction,
        fromDate?: string,
        toDate?: string,
        limit?: number,
        page?: number,
    ): CancelablePromise<TListAuditLogResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/audit-log',
            query: {
                'entityName': entityName,
                'actorUserId': actorUserId,
                'action': action,
                'fromDate': fromDate,
                'toDate': toDate,
                'limit': limit,
                'page': page,
            },
        });
    }
}
